import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
// import { AuthProvider } from './contexts/AuthContext';
// import { CartProvider } from './contexts/CartContext';
// import Navbar from './components/Navbar';
// import Footer from './components/Footer';
// import Home from './pages/Home';
// import Menu from './pages/Menu';
// import About from './pages/About';
// import Contact from './pages/Contact';
// import Cart from './pages/Cart';
// import Login from './components/Login';
// import Signup from './components/Signup';
// import AdminApp from './admin/AdminApp';
import UnderConstruction from './pages/UnderConstruction';

function App() {
  return (
    <Routes>
      <Route path="/maintenance" element={<UnderConstruction />} />
      <Route path="*" element={<Navigate to="/maintenance" replace />} />
    </Routes>
  );
}

export default App; 